import BaseModal from '@/components/BaseModal';
import { checkShowErrorInline } from '@/helpers';
import useToast from '@/hooks/useToast';
import { apiCaller } from '@/redux/query';
import { LegacyStack, Text, TextField } from '@shopify/polaris';
import { memo, useEffect, useState } from 'react';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const ApplyDiscountModal = ({ open, onClose }: IProps) => {
  const { show } = useToast();
  const [value, setValue] = useState<string>('');
  const [error, setError] = useState('');
  const [applyDiscountCode, { isLoading }] = apiCaller.useAddDiscountCodeMutation();

  const handleChange = (value: string) => {
    setValue(value);
    if (!value) setError('You have not entered the discount code');
    else if (error && value) setError('');
  };

  const handleApplyDiscount = async () => {
    const res = await applyDiscountCode({ discountCode: value });
    const checkError = checkShowErrorInline(res);
    if (checkError.status) {
      // @ts-ignore: Unreachable code error
      setError(checkError.msg || res?.data?.message);
    } else {
      show('Saved');
      onClose();
    }
  };

  useEffect(() => {
    if (!open) setValue('');
  }, [open]);

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Apply discount code"
      primaryAction={{
        content: 'Apply',
        onAction: handleApplyDiscount,
        disabled: !value,
        loading: isLoading,
      }}
    >
      <LegacyStack vertical>
        <LegacyStack.Item>
          <TextField label="Discount code:" value={value} onChange={handleChange} autoComplete="off" error={error} />
          <div className="mt-8">
            <Text as="p">
              <b>Note: </b>
              <ul>
                <li>Deducted price is shown on the Approve Subscription page.</li>
                <li>Discount code does not apply to yearly plans.</li>
                <li>Discount code does not deduct your current plan charge.</li>
              </ul>
            </Text>
          </div>
        </LegacyStack.Item>
      </LegacyStack>
    </BaseModal>
  );
};

export default memo(ApplyDiscountModal);
